// import React, { useEffect, useState } from "react";
// import "./print-certificate.css"; // Add your print styles here

// import { linkPath } from "../../share/helper";
// import { getCurrentUser, getImagelink_org_logo } from "../../share/getProfile";
// import dayjs from "dayjs";
// import QRCode from "react-qr-code";
// import QRWithIcon from "./qrcodeicon";
// import { Col, Row } from "antd";
// import { request } from "../../share/request";
// import { BiCheckCircle } from "react-icons/bi";

// const PrintCertificate = React.forwardRef(
//   ({ background_image, content }, ref) => {
//     const [Org_ImagePath, SetOrgImagePath] = useState(
//       "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
//     );
//     const OrgProfile = getCurrentUser();
//     const [data, setData] = useState([]);

//     useEffect(() => {
//       const fetchProfile = async () => {
//         setData(
//           JSON.parse(localStorage.getItem("selectedFullnames_isCheck")) || []
//         );
//       };
//       console.table(data);
//       const fetchLogo = async () => {
//         const logo = await getImagelink_org_logo("logo");
//         if (logo) SetOrgImagePath(linkPath + logo);
//       };
//       fetchLogo();
//       fetchProfile();
//     }, []);

//     return (
//       <div ref={ref} className="print-page-container">
//         {data.map((item, index) => {
//           const fullname = item?.fullname || "Unknown";
//           const htmlContent = content
//             ? content.replace("{{fullname}}", fullname)
//             : "";
//           return (
//             <div
//               ref={ref}
//               className="print-page"
//               style={{
//                 backgroundImage: `url(${background_image})`,
//               }}
//             >
//               <div className="content-wrapper">
//                 {/* Header */}
//                 <div
//                   style={{
//                     textAlign: "center",
//                     paddingBottom: "10px",
//                   }}
//                 >
//                   <div>
//                     <div className="header-text">
//                       <span>ព្រះរាជាណាចក្រកម្ពុជា</span> <br />
//                       <span>ជាតិ សាសនា ព្រះមហាក្សត្រ</span>
//                       <br />
//                       <img
//                         src="https://static.vecteezy.com/system/resources/previews/044/771/216/non_2x/classic-ornate-border-element-vintage-ornament-isolated-on-white-background-decorative-line-for-frame-page-template-poster-greeting-card-free-png.png"
//                         alt="tacteing font"
//                         style={{ width: "10%" }}
//                       />
//                     </div>
//                   </div>

//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between", // this is the correct property
//                       alignItems: "flex-start", // optional: align tops
//                       width: "100%",
//                     }}
//                   >
//                     {/* head Name is left  */}
//                     <div
//                       style={{
//                         textAlign: "start",
//                       }}
//                     >
//                       <img
//                         src={Org_ImagePath}
//                         alt="Organization Logo"
//                         style={{
//                           width: "80px",
//                           height: "80px",
//                           marginBottom: "5px",
//                           marginLeft: 20,
//                         }}
//                       />
//                       <span>
//                         {OrgProfile.org_type <= 3 && (
//                           <span className="header-text">
//                             <br /> រដ្ឋបាល{OrgProfile.province_name} <br />
//                           </span>
//                         )}
//                         {OrgProfile.org_type >= 4 && (
//                           <span className="header-text">
//                             <br /> មន្ទីរសុខាភិបាលនៃរដ្ឋបាល <br />
//                           </span>
//                         )}
//                       </span>

//                       {OrgProfile.org_type != 1 && (
//                         <span className="header-text">
//                           {/* {OrgProfile.org_cover_by} <br /> */}
//                           មន្ទីរសុខាភិបាលនៃរដ្ឋបាល <br />
//                         </span>
//                       )}
//                       <span className="header-text">
//                         {OrgProfile.org_name_kh}
//                       </span>
//                       <br />
//                     </div>
//                     {/* QRcode image  rigth */}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-end",
//                         width: 300,
//                       }}
//                     >
//                       <QRWithIcon
//                         value={
//                           "https://blood-donation-pi-green.vercel.app/" +
//                           data.ingerate_qrcode_id
//                         }
//                         iconUrl={Org_ImagePath}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 {/* Conter of content  */}
//                 <div style={{ width: "100%", lineHeight: "1.2" }}>
//                   <div
//                     dangerouslySetInnerHTML={{ __html: htmlContent }}
//                     style={{
//                       fontFamily: '"Khmer OS Content", Arial, sans-serif',
//                       lineHeight: "1.2",
//                     }}
//                   />
//                 </div>
//                 {/* Footer */}
//                 <div
//                   className="print-footer"
//                   style={{
//                     marginTop: "20px",
//                     textAlign: "right",
//                     paddingTop: "10px",
//                   }}
//                 >
//                   {/* footer  */}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   }
// );

// export default PrintCertificate;

import React, { useEffect, useState } from "react";
import "./print-certificate.css"; // Add your print styles here
import { linkPath } from "../../share/helper";
import { getCurrentUser, getImagelink_org_logo } from "../../share/getProfile";
import dayjs from "dayjs";
import QRWithIcon from "./qrcodeicon";

const PrintCertificate = React.forwardRef(
  ({ background_image, content }, ref) => {
    const [Org_ImagePath, SetOrgImagePath] = useState(
      "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
    );
    const OrgProfile = getCurrentUser();
    const [data, setData] = useState([]);

    useEffect(() => {
      const fetchLogo = async () => {
        const logo = await getImagelink_org_logo("logo");
        if (logo) SetOrgImagePath(linkPath + logo);
      };
      const fetchProfile = async () => {
        const storedData =
          JSON.parse(localStorage.getItem("selectedFullnames_isCheck")) || [];
        console.log('data postion: ', storedData)
        setData(storedData);
        console.table(storedData); // Log after setting state
      };
      fetchLogo();
      fetchProfile();
    }, [background_image, OrgProfile, data]);

    return (
      <div ref={ref} className="print-page-container">
        {data.map((item, index) => {
          const fullname = item?.fullname || "";
          const position = item?.position || '';
          // Replace {{fullname}} and {{position}} inside the HTML template
          const htmlContent = content
            ? content
              .replace("{{fullname}}", fullname)
              .replace("{{position}}", position)
            : "";
          const qrcodeValue = item?.qrcode
            ? `https://blood-donation-pi-green.vercel.app/${item.qrcode}`
            : "https://blood-donation-pi-green.vercel.app/";

          return (
            <div
              key={index} // Unique key for each page
              className="print-page"
              style={{
                backgroundImage: `url(${background_image})`,
                position: "relative",
                width: "210mm", // A4 width
                minHeight: "297mm", // A4 height as minimum
                margin: "0 auto",
                padding: "15mm", // Match CSS padding
                boxSizing: "border-box",
                pageBreakAfter: index < data.length - 1 ? "always" : "auto", // Ensure page breaks
              }}
            >
              <div className="content-wrapper">
                {/* Header */}
                <div
                  style={{
                    textAlign: "center",
                    paddingBottom: "10px",
                  }}
                >



                </div>
                {/* Center of content */}
                <div style={{ width: "100%", lineHeight: "1.2" }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: htmlContent }}
                    style={{
                      fontFamily: '"Content", Arial, sans-serif',
                      lineHeight: "1.2",
                    }}
                  />
                </div>
                <QRWithIcon value={qrcodeValue} iconUrl={Org_ImagePath} />
                {/* Footer */}
                <div
                  className="print-footer"
                  style={{
                    marginTop: "20px",
                    textAlign: "right",
                    paddingTop: "10px",
                  }}
                >
                  {/* change later */}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
);

export default PrintCertificate;
